<template>
    <UIRipple
        class="x-product-item pt-3 pb-3"
        color="black"
        :opacity="0"
        tag="nuxt-link"
        :to="$brand.getPath(brand)"
        :title="$brand.getName(brand)"
    >
        <div class="d-md-flex">
            <div class="d-flex align-items-center flex-grow-1">
                <div class="fixed-width mr-3">
                    <ProductImage :product="product" :width="110"></ProductImage>
                </div>

                <div class="info flex-grow-1">
                    <div class="font-weight-bold">
                        <template>{{ $brand.getName(brand) }}</template>
                    </div>
                    <div class="delivery">
                        <div class="d-flex align-items-center">
                            <Flame class="flame-icon"></Flame>
                            <Envelope class="envelope-icon mr-2"></Envelope>
                            <span class="text-light small">{{ translate('cart.delivery.type') }}</span>
                        </div>
                    </div>
                    <div v-if="productList" class="prices d-none d-md-block">
                        <span
                            v-for="item in productList"
                            :key="item.id"
                            class="product-label mr-2 mt-2 d-inline-flex text-light small"
                            @click.prevent.stop="$router.push($product.getPath({ ...item, brand }))"
                            >{{ priceTag(item) }}</span
                        >
                        <span
                            v-if="productList.length < brand.products.length"
                            class="product-label mr-2 mt-2 d-inline-flex text-light small"
                            @click.prevent.stop="$router.push($brand.getPath(brand))"
                        >
                            ...
                        </span>
                    </div>
                </div>
            </div>
            <div v-if="productList" class="prices mt-2 d-block d-md-none">
                <span
                    v-for="item in productList"
                    :key="item.id"
                    class="product-label mr-2 mt-2 d-inline-flex text-light small"
                    @click.prevent.stop="$router.push($product.getPath({ ...item, brand }))"
                    >{{ priceTag(item) }}</span
                >
                <span
                    v-if="productList.length < brand.products.length"
                    class="product-label mr-2 mt-2 d-inline-flex text-light small"
                    @click.prevent.stop="$router.push($brand.getPath(brand))"
                >
                    ...
                </span>
            </div>
            <div class="button-container d-flex flex-row align-items-center ml-auto">
                <UIButton variant="default">
                    {{ translate('button.visit') }}
                </UIButton>
            </div>
        </div>
    </UIRipple>
</template>

<script>
import { UIButton, UIRipple } from '@dundle/ui/components';
import { mapActions } from 'vuex';
import { ProductImage } from '~/components/product';
import TranslationMixin from '~/mixins/TranslationMixin';
import Envelope from '~/assets/icons/envelope.svg';
import Flame from '~/assets/icons/flame.svg';

export default {
    components: {
        UIRipple,
        UIButton,
        ProductImage,
        Envelope,
        Flame,
    },
    mixins: [TranslationMixin],

    props: {
        brand: {
            type: Object,
            required: true,
        },
    },

    computed: {
        product() {
            return {
                ...this.brand.products[0],
                brand: {
                    slug: this.brand.slug,
                    name: this.brand.name,
                    category: this.brand.category,
                    productName: {
                        value: null,
                    },
                },
            };
        },

        productList() {
            return this.product.unitType === 'value'
                ? this.brand.products.slice(0, 4)
                : this.brand.products.slice(0, 2);
        },
    },

    methods: {
        ...mapActions({
            addProductInCart: 'cart/addItem',
        }),
        priceTag(product) {
            return this.$product.getTextValue(product);
        },
    },
};
</script>

<style lang="scss" scoped>
.x-product-item {
    display: block;
    background-color: #fff;
    border-bottom: 1px solid $color-grey-3;

    @media screen and (max-width: 767px) {
        &:not(:first-child) {
            margin-top: 10px;
        }

        &:not(:last-child) {
            margin-bottom: 10px;
        }
    }

    &:hover {
        background-color: $color-primary-light;
    }

    .fixed-width {
        width: 110px;
        position: relative;
    }

    .delivery {
        span {
            font-size: 0.85rem;
        }
        .flame-icon {
            color: $color-flame;
        }
        .envelope-icon {
            color: $color-primary;
        }
        svg {
            height: 0.88rem;
        }
    }

    &:hover,
    &:active {
        text-decoration: none;
    }

    .product-label {
        background-color: white;
        border: 1px solid $color-grey-3;
        border-radius: 2px;
        padding: 0.1rem 0.6rem;
        color: $color-grey-5;
        &:hover {
            text-decoration: none;
            color: $color-text-inverted !important;
            background-color: $color-primary !important;
            border: 1px solid $color-primary;
            cursor: pointer;
        }
    }

    .button-container,
    .button-container button {
        min-width: 150px;
    }

    @media screen and (max-width: 768px) {
        padding: 0 15px;

        .touch-UIRipple {
            display: none;
        }

        .button-container {
            display: none !important;
        }
    }
}
</style>

<i18n src="@dundle/locale/data/keywords.json"></i18n>
<i18n src="@dundle/locale/data/buttons.json"></i18n>
<i18n src="@dundle/locale/data/countries.json"></i18n>
<i18n src="@dundle/locale/data/cart.json"></i18n>
